import { general } from './general';

export const textarea = (data = {}) => general('textarea', (data || {}));
